// src/App.jsx
import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ConfigProvider } from './contexts/ConfigContext';
import { PagesProvider } from './contexts/PagesContext';
import ScrollToTop from './components/ScrollToTop';
import DynamicStyles from './components/DynamicStyles';
import Header from './components/Header';
import BookingStrip from './components/BookingStrip';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import { X } from 'lucide-react'; // 🔥 IMPORTAÇÃO DO ÍCONE ADICIONADA

// Páginas Públicas
import Home from './pages/Home';
import Pousada from './pages/Pousada';
import Quartos from './pages/Quartos';
import Localizacao from './pages/Localizacao';
import Contato from './pages/Contato';

// Páginas Admin
import Login from './pages/admin/Login';
import AdminLayout from './pages/admin/AdminLayout';
import Dashboard from './pages/admin/Dashboard';
import Customize from './pages/admin/Customize';
import TextEditor from './pages/admin/TextEditor';
import SiteImages from './pages/admin/SiteImages';
import GalleryAdmin from './pages/admin/GalleryAdmin';
import PagesManager from './pages/admin/PagesManager';
import Settings from './pages/admin/Settings';

import './styles/main.css';
import './styles/admin-styles.css';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem('isAdminAuthenticated') === 'true';
  return isAuthenticated ? children : <Navigate to="/admin" />;
};

function App() {
  // 🔥 ESTADOS DO COOKIE ADICIONADOS AQUI
  const [cookiesAccepted, setCookiesAccepted] = useState(
    localStorage.getItem('site_cookie_accepted') === 'true'
  );
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    // Lógica para mostrar o banner inicial se não estiver aceito
    if (!cookiesAccepted) {
      const timer = setTimeout(() => setShowCookieBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, [cookiesAccepted]);

  // 🔥 FUNÇÕES DE CONTROLE DO COOKIE
  const handleAcceptCookies = () => {
    localStorage.setItem('site_cookie_accepted', 'true');
    setCookiesAccepted(true);
    setShowCookieBanner(false);
  };

  const handleCloseBanner = () => {
    setShowCookieBanner(false);
  };

  return (
    <ConfigProvider>
      <PagesProvider>
        <DynamicStyles />
        
        {/* 🔥 BOTÃO FLUTUANTE DE WHATSAPP (todas as páginas) */}
        <WhatsAppButton />

        {/* 🔥 BANNER DE COOKIES GLOBAL */}
        {showCookieBanner && (
          <div className="cookie-consent-overlay" style={{ zIndex: 2147483647 }}>
            <div className="cookie-consent-banner">
              <div className="cookie-content">
                <h3>Aviso de Cookies</h3>
                <p>Utilizamos cookies para oferecer a melhor experiência em nosso site. Ao continuar, você concorda com o uso.</p>
              </div>
              <div className="cookie-actions">
                <button onClick={handleAcceptCookies} className="cookie-btn-accept">Aceitar</button>
                <button onClick={handleCloseBanner} className="cookie-btn-close"><X size={20} /></button>
              </div>
            </div>
          </div>
        )}

        <Router>
          <ScrollToTop />
          <Routes>
            {/* Rotas Públicas */}
            <Route path="/" element={<><Header /><BookingStrip /><Home /><Footer /></>} />
            <Route path="/a-pousada" element={<><Header /><BookingStrip /><Pousada /><Footer /></>} />
            <Route path="/quartos" element={<><Header /><BookingStrip /><Quartos /><Footer /></>} />
            <Route path="/localizacao" element={<><Header /><BookingStrip /><Localizacao /><Footer /></>} />
            <Route path="/contato" element={<><Header /><BookingStrip /><Contato /><Footer /></>} />

            {/* Rotas Admin */}
            <Route path="/admin" element={<Login />} />
            <Route path="/admin" element={<PrivateRoute><AdminLayout /></PrivateRoute>}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="customize" element={<Customize />} />
              <Route path="texts" element={<TextEditor />} />
              <Route path="images" element={<SiteImages />} />
              <Route path="gallery" element={<GalleryAdmin />} />
              <Route path="pages" element={<PagesManager />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </PagesProvider>
    </ConfigProvider>
  );
}

export default App;